import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Comment, MovieModel } from 'src/app/core/interfaces/movie.model';
import { Account } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-comments-section',
  templateUrl: './comments-section.component.html',
  styleUrls: ['./comments-section.component.scss']
})
export class CommentsSectionComponent implements OnInit, OnDestroy {

  @Input() Movie: MovieModel;
  Comments: Comment[] = [];

  loading: Boolean = false;
  isLogged: Boolean = false;
  loggedAccount: Account;

  modalReview: any;
  reviewSelected: Comment;
  isBrowser: boolean;

  subscribeLogin: Observable<Boolean>;

  constructor(
    private moviesService: MoviesService,
    private accountService: AccountService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) platformId,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.chequearLogin();
    this.cargarComments();
    if (this.isBrowser) {
      this.modalReview = $('#modalReview');
    }
  }

  cargarComments() {
    this.loading = true;
    this.moviesService.getCommentsByMovie(this.Movie.id).subscribe((res) => {
      this.Comments = res;
      this.Comments.forEach(c => {
        c.movieModel = this.Movie;
      });

      this.loading = false;
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
        this.loading = false;
      },
    );
  }

  chequearLogin() { //COMPRUEBA QUE ESTES LOGEADO Y CARGA TODO.

    let estado = this.authService.getUserLogged();
    if (estado == true) {
      this.accountService.getAccountNoRedirect().then(
        (res: Account) => {
          if (res) {
            if (res == null) {
              //NO LOGEADO
              this.isLogged = estado;
            }
            else {
              //LOGEADO
              this.loggedAccount = res;
              this.isLogged = estado;
            }
          }
        },
        (error) => {
          //ERROR - NO LOGEADO
          this.isLogged = estado;
        },
      );
    }
  }

  openReview(review: Comment) {
    // this.modalReview = $('#modal');
    this.reviewSelected = review;
    this.modalReview.modal('show');
  }

  closeReview() {
    this.modalReview.modal('hide');
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    if (this.modalReview) this.modalReview.modal('hide');
  }

}
